(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairGeneralInformationController', VirtualFairGeneralInformationController);
        VirtualFairGeneralInformationController.$inject = ['VirtualFairService', 'isPlatformRental', 'virtualFairs', 'ExpoService', '$uibModal'];
    function VirtualFairGeneralInformationController(VirtualFairService, isPlatformRental, virtualFairs) {
        var vm = this;

        vm.selectVirtualFairs               = selectVirtualFairs;
        vm.getByFilter                      = getByFilter;
        vm.mountGraphTop10CourseInterest    = mountGraphTop10CourseInterest;
        vm.activate                         = activate;
        vm.resetGraph                       = resetGraph;
        
        vm.virtualFairSelected              = '';
        vm.flag                             = false;
        vm.isPlatformRental                 = isPlatformRental;

        function selectVirtualFairs () {
            if(virtualFairs) {
                vm.virtualFairs = virtualFairs;
            } else {
                let query ={}
                query['with_stats'] = 1;
                query['order_by'] = 'DESC';
                VirtualFairService.getAll(query).then(function(response) {
                    vm.virtualFairs = response.data;
                });
            }
        }

        function getByFilter () {
            vm.flag = false;
            let query = {};
            query['virtual_fair_id'] = vm.virtualFairSelected;
            if(vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }
            vm.resetGraph();
            VirtualFairService.getGeneralInformation(query).then(function(response) {
                vm.flag = true;
                vm.generalInformation = response.data;
                vm.mountGraphTop10CourseInterest(vm.generalInformation.total_course_interest);
            });
        }

        function resetGraph () {
            vm.graphTop10CourseInterest         = {data: [], labels: [], colors: [], options: {
                responsive: true,
                scales: {
                    xAxes: [{
                        ticks: {
                            // suggestedMin: 50,
                            // suggestedMax: 100,
                            callback: function (value) {
                                return value + '%'; // convert it to percentage
                            },
                        }
                    }],
                },
                tooltips: {
                    callbacks: {
                        label: function(t, d) {
                            return t.xLabel + '%';
                        }
                    }
                }
            }};
        }

        function activate () {
            vm.selectVirtualFairs();
            vm.resetGraph();
        }

        function mountGraphTop10CourseInterest (data) {
            angular.forEach(data, function(value, key) {
                vm.graphTop10CourseInterest.data.push(value.percent);
                vm.graphTop10CourseInterest.labels.push(value.label);
                vm.graphTop10CourseInterest.colors.push('#05a9f4');
            });
        }

        vm.activate();
    }
})();